module.exports = __webpack_public_path__ + "media/images/app/about/dobri-e0054c59d9544d37a906d2261da4586f.webp";